import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  ButtonGroup,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  Switch
} from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { useLocation } from 'react-router';
import dashboardTimeFrameAtom, {
  mcscAtom,
  refetchInternalTicketsAtom,
  selectedMCSCAssessmentAtom,
  selectedMCSCAssessmentIdAtom
} from '@/pages/Dashboard/Dashboard.store';
import type { MyCyberScorecardDTO } from '@/pages/Dashboard/Dashboard.types';
import { DASHBOARD_TIMEFRAMES } from '@/pages/Dashboard/dashboard.constants';

const DashboardButtons = () => {
  const { pathname } = useLocation();
  const [, setSelectedAssessmentId] = useAtom(selectedMCSCAssessmentIdAtom);
  const selectedMCSCAssessment = useAtomValue(selectedMCSCAssessmentAtom);
  const mcscData = useAtomValue(mcscAtom);
  const [refetchInternalTickets, setRefetchInternalTickets] = useAtom<boolean>(
    refetchInternalTicketsAtom
  );

  const [dashboardTimeFrame, setDashboardTimeFrame] = useAtom(
    dashboardTimeFrameAtom
  );

  const newHandleTimeChange = (value: number) => {
    setDashboardTimeFrame(value);
  };

  const handleAssessmentChange = (value: string) => {
    const assessment = mcscData?.find(
      (item: MyCyberScorecardDTO) => item.assessment_name === value
    );
    setSelectedAssessmentId(assessment?.assessment_id || null);
  };

  const orgAssessments = mcscData?.map((item) => item.assessment_name) || [];

  return (
    <ButtonGroup>
      {pathname === '/dashboard/internal' && (
        <>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={refetchInternalTickets}
                  onChange={() => setRefetchInternalTickets((prev) => !prev)}
                />
              }
              label="Auto Refresh"
            />
          </FormGroup>
          <Button
            onClick={() => window.open('/internal-tickets', '_blank')}
            variant="contained"
            color="primary"
            size="small"
          >
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </Button>
        </>
      )}
      {pathname !== '/dashboard/mcsc' &&
        pathname !== '/dashboard/internal' &&
        DASHBOARD_TIMEFRAMES.map((timeFrameItem) => (
          <Button
            key={timeFrameItem.value}
            onClick={() => newHandleTimeChange(timeFrameItem.value)}
            variant={
              timeFrameItem.value === dashboardTimeFrame
                ? 'contained'
                : 'outlined'
            }
            size="small"
            value={timeFrameItem.value}
          >
            {timeFrameItem.label}
          </Button>
        ))}
      {pathname === '/dashboard/mcsc' && orgAssessments.length > 1 && (
        <Select
          value={selectedMCSCAssessment?.assessment_name}
          onChange={(e) => handleAssessmentChange(e.target.value)}
          variant="outlined"
          size="small"
        >
          {orgAssessments?.map((item: string) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      )}
    </ButtonGroup>
  );
};

DashboardButtons.displayName = 'DashboardButtons';

export default DashboardButtons;
